import { cn } from "@/lib/utils"
import { cva, type VariantProps } from "class-variance-authority"
import React from "react"

const cardVariants = cva("rounded-xl border border-border", {
  variants: {
    variant: {
      interactive: "card-hover bg-card/30 p-5",
      static: "bg-card/20 p-4",
      content: "bg-card/20 p-6",
    },
  },
  defaultVariants: {
    variant: "interactive",
  },
})

type CardProps<T extends React.ElementType = "div"> = {
  as?: T
  className?: string
} & VariantProps<typeof cardVariants> &
  Omit<React.ComponentPropsWithoutRef<T>, "as" | "className">

function Card<T extends React.ElementType = "div">({
  as,
  className,
  variant,
  ...props
}: CardProps<T>) {
  const Comp = (as ?? "div") as React.ElementType
  return React.createElement(Comp, {
    ...(props as Record<string, unknown>),
    className: cn(cardVariants({ variant, className })),
  })
}

export { Card, cardVariants }
export type { CardProps }
